import moment from 'moment'

const timestampFormatter = (dateObject, format = 'M/DD/YYYY') => {
  const formattedTime = dateObject ? moment(dateObject).format(format) : moment(new Date()).format(format)
  return formattedTime
}

export default timestampFormatter
